module.exports = __webpack_public_path__ + "static/sport/ruleboximg3.8b2cea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/ruleboximg3.png
// module id = r2aX
// module chunks = 0